import { useSWRFetch } from './internal/useSWRFetch';
import { getProductInfoDialogShowMrpStatement } from '../api';
export var useGetProductInfoDialogShowMrpStatement = function useGetProductInfoDialogShowMrpStatement(_ref) {
  var staticApiUrl = _ref.staticApiUrl,
    tenant = _ref.tenant;
  return useSWRFetch({
    fallback: false,
    fetcher: async function fetcher() {
      return getProductInfoDialogShowMrpStatement({
        staticApiUrl: staticApiUrl,
        tenant: tenant
      });
    },
    key: [staticApiUrl, tenant]
  });
};